<ng-container *ngIf="isButton">
  <button
    mat-stroked-button
    [ngClass]="styleClass || null"
    [color]="color || 'primary'"
    (click)="downloadTemplate()"
    [disabled]="disabled"
  >
    {{ text }}
    <i *ngIf="disabled" nz-icon nzType="sync" nzSpin class="u-marginLeft-8"></i>
  </button>
</ng-container>
<ng-container *ngIf="!isButton">
  <button
    class="c-button"
    [ngClass]="styleClass ? styleClass : 'color-blue'"
    (click)="downloadTemplate()"
    [disabled]="disabled"
  >
    {{ text }}
  </button>
</ng-container>
